export const realtorPortalAccessToggleStyles = { mt: 1 };
